<template lang="pug">
  .flow-builder-gallery-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    .mb-3
      b-form-group(v-for="(t_a, t_a_index) in Template_Attributes", :key="t_a.template_attribute_id", v-if="t_a.name == 'iterable'", :id="`template_attribute_${t_a.template_attribute_id}`")
        b-form-checkbox(:checked="parseBoolean(t_a.value)", :state="parseBoolean(t_a.value) && Elements.length > 1 ? false : null", @change="updateTemplateAttribute(t_a, $event)", :disabled="disabled") Iterar galería
        b-form-invalid-feedback(:state="parseBoolean(t_a.value) && Elements.length > 1 ? false : null") Se itera el primer elemento, se ignoran los demás
    .gallery-elements-row.mb-3(:id="'gallery_elements_' + template_id + '_' + disabled")
      gallery-element(v-for="(element, element_index) in Elements", :key="element.element_id", v-if="element.type == 'gallery_element'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", @destroy="destroyTemplateElement(element)", :ignored="parseBoolean(getAttribute('iterable') ? getAttribute('iterable').value : null) && element_index > 0")
      .add-generic-template.not-draggable(v-if="!disabled", @click="createTemplateElement")
        p.mb-0.text-center Agregar elemento +
</template>

<script>
import templateCommon from '@/helpers/template-common'
import GalleryElement from '@/components/templates/GalleryElement.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import Sortable from 'sortablejs'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  components: {
    GalleryElement,
    TemplateTools
  },
  created () {
    this.createTemplateElement = () => {
      let self = this
      let element = {
        type: 'gallery_element',
        number: self.Elements.length + 1,
        attributes: [
          {
            name: 'title',
            value: ''
          },
          {
            name: 'subtitle',
            value: ''
          },
          {
            name: 'image_url',
            value: ''
          }
        ]
      }

      this.createElement(this.block_id, this.template_id, element)
    }

    this.destroyTemplateElement = (element) => {
      this.destroyElement(this.block_id, this.template_id, element)
    }

    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    }, 0, { leading: false, trailing: true })
  },
  mounted () {
    let self = this

    if (!this.disabled) {
      // elements sortable
      var el = document.getElementById('gallery_elements_' + this.template_id + '_' + this.disabled)
      var sortable = new Sortable(el, {
        handle: '.template-element-tool-move',
        draggable: '.gallery-element',
        direction: 'horizontal',
        ghostClass: 'draggable-ghost-class',
        filter: '.not-draggable',
        onMove: function (event) {
          return event.related.className.indexOf('no-sortable') === -1;
        },
        onEnd: function (event) {
          let oldIndex = event.oldIndex
          let newIndex = event.newIndex

          self.$store.commit('block/reorderElements', {
            block_id: self.block_id,
            template_id: self.template_id,
            oldIndex: oldIndex,
            newIndex: newIndex
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-gallery-template {
    flex: 1 0 auto;
    width: 100%;
    background-color: transparent;
    position: relative;
    box-sizing: border-box;

    .gallery-elements-row {
      display: inline-flex;
      align-items: flex-start;
      justify-content: flex-start;
      white-space: normal;
      width: 100%;
      position: relative;
      box-sizing: border-box;
      overflow-x: auto;
      padding: 0.8rem 0;
    }

    .gallery-elements-row::-webkit-scrollbar {
      height: 0.7rem;
    }

    .gallery-elements-row::-webkit-scrollbar-track {
      border: 1px solid #000;
      padding: 2px 0;
      background-color: #404040;
      border-radius: 10px;
    }

    .gallery-elements-row::-webkit-scrollbar-thumb {
      border: 1px solid #000;
      border-radius: 10px;
      background-color: $primary;
    }

    .add-generic-template {
      flex: 0 0 auto;
      min-width: 0;
      width: 100%;
      height: 197.75px;
      max-width: 70%;
      background-color: white;
      border-radius: 1rem;
      word-break: break-word;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 15px;

      border: 1.5px dashed $light-primary;
      background-color: transparent;
      color: $light-primary !important;
      cursor: pointer;
    }
  }
</style>
